export enum SearchVersionsEnum {
  original = 'a',
  variant_1 = 'a',
  variant_2 = 'b',
  variant_3 = 'c'

}
